import React from 'react';
import SphereAvatar from '../sphere-avatar/sphere-avatar';
import { Sphere } from 'types/global';
import './SphereTypeAvatar.scss';

interface SphereTypeAvatarProps {
  sphere: Sphere; // Sphere type
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void; // Click handler
  editable?: boolean;
  title?: string; // Title
  sphereId?: string; // Sphere ID for avatar display
}

const SphereTypeAvatar: React.FC<SphereTypeAvatarProps> = ({
  sphere,
  onClick,
  editable = true,
  title,
  sphereId,
}) => {
  const glyph = sphere.glyph ?? 'default-icon';
  // A span, not a div: the content sits inside a <span> or a <button>, which take phrasing content only.
  const containerContent = (
    <span className="avatar-container" title={title}>
      <SphereAvatar glyph={glyph} glyphColor={sphere.glyphColor} size="small" sphereId={sphereId} />
      {/* Dropdown Icon */}
      {editable && (
        <span className="dropdown-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
          >
            <path
              d="M7.82191 8.66505C7.74441 8.7659 7.62667 8.85053 7.48166 8.90963C7.33663 8.96873 7.16996 9 6.99999 9C6.83002 9 6.66336 8.96873 6.51834 8.90963C6.37331 8.85053 6.25557 8.7659 6.17807 8.66505L1.09879 1.89272C1.02795 1.79901 0.99422 1.69478 1.00081 1.58987C1.0074 1.48502 1.05408 1.38307 1.13644 1.29361C1.21879 1.20416 1.33407 1.13021 1.47133 1.07887C1.60859 1.02746 1.76329 1.00031 1.92071 1H12.0793C12.2367 1.00031 12.3913 1.02746 12.5287 1.07887C12.6659 1.13021 12.7812 1.20416 12.8635 1.29361C12.9459 1.38307 12.9925 1.48502 12.9992 1.58987C13.0058 1.69478 12.972 1.79901 12.9012 1.89272L7.82191 8.66505Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </span>
  );

  if (!editable) {
    return <span className="sphere-avatar-wrapper" title={title}>{containerContent}</span>;
  }

  return (
    <button className="sphere-avatar-wrapper" onClick={onClick} title={title} type="button">
      {containerContent}
    </button>
  );
};

export default SphereTypeAvatar;
